var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 72 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C9.32843 2 10 2.67157 10 3.5V16.5C10 17.3284 9.32843 18 8.5 18C7.67157 18 7 17.3284 7 16.5V3.5C7 2.67157 7.67157 2 8.5 2Z",
    fill: "#013380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 73 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2C14.3284 2 15 2.67157 15 3.5V16.5C15 17.3284 14.3284 18 13.5 18C12.6716 18 12 17.3284 12 16.5V3.5C12 2.67157 12.6716 2 13.5 2Z",
    fill: "#013380"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.57e658372372480c78eace6ce3715460.svg";
export { ForwardRef as ReactComponent };